import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Postrequestcall } from "../../request/Postrequest";
import {
  FETCH_PROJECT_SITE_PRODUCTS,
  GET_SITE_FOLLOWING_PRODUCTS,
  SAVE_FOLLOWING_PRODUCTS,
  SAVE_SITE_PRODUCTS
} from "../../constant/Apipath";
import {
  setSelectedProjectdata,
  setSelectedsite,
  setSelectedSiteId,
  setShowmapmodal,
  setShowReport
} from "../../redux/actions/actions";
import Emptydata from "../common/Emptydata";
import {
  Box,
  Button,
  Card,
  Icon,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  ListSubheader,
  Menu,
  MenuItem,
  Stack,
  Typography
} from "@mui/material";
import { MoreVert as MoreIcon, Build as BuildIcon } from "@mui/icons-material";
import Loader from "../../common/Loader";
import InfiniteScroll from "react-infinite-scroll-component";
import { BIGrey, BIRed } from "../../assets/helpers";
import AddProductModal from "../common/AddProductModal";
import Pages from "../../constant/ReportModel";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import PromptModal from "../common/PromptModal";
import { Getrequestcall } from "../../request/Getrequest";
import { English } from "../../constant/EnglishFallback";
import { CompanyListSkeleton } from "../skeleton/SkeletonView";

const SitesProductSection = ({ siteId, scrollId, activeTab }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { loginData, multiLanguageData, reportSuccess } = useSelector((state) => state?.main);

  const LanguageData = multiLanguageData?.SiteDetail || {};
  const {
    TEXT_PRODUCTS = English.SiteDetail.TEXT_PRODUCTS,
    TEXT_ADD_PRODUCT = English.SiteDetail.TEXT_ADD_PRODUCT,
    TEXT_NO_PRODUCTS_ADDED_YET = English.SiteDetail.TEXT_NO_PRODUCTS_ADDED_YET,
    TEXT_REPORT = English.SiteDetail.TEXT_REPORT,
    TEXT_NO_RESULTS_FOUND = English.SiteDetail.TEXT_NO_RESULTS_FOUND,
    TEXT_FOLLOW_ALL = English.SiteDetail.TEXT_FOLLOW_ALL,
    TEXT_FOLLOWING_ALL = English.SiteDetail.TEXT_FOLLOWING_ALL,
    TEXT_NO_ROLE = English.SiteDetail.TEXT_NO_ROLE,
    TEXT_FOLLOW_ALERT = English.SiteDetail.TEXT_FOLLOW_ALERT,
    TEXT_UNFOLLOW_ALERT = English.SiteDetail.TEXT_UNFOLLOW_ALERT,
    TEXT_YES = English.SiteDetail.TEXT_YES
  } = LanguageData || {};

  const currentUserId = loginData?.userInformation?.UserId ?? 0;

  const [productData, setProductData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [moreMenuAnchorEl, setMoreMenuAnchorEl] = useState(null);
  const [showSearchLoader, setShowSearchLaoder] = useState(false);
  const [hasData, setHasData] = useState(false);
  const [showAddProductModal, setShowAddProductModal] = useState(false);
  const [product, setProduct] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [allDataLoaded, setAllDataLoaded] = useState(false);
  const [noOfProject, setNoOfProject] = useState(null);
  const [allFollowing, setAllFollowing] = useState(false);
  const [removeProductAlert, setRemoveProductAlert] = useState(false);
  const [followFlag, setFollowFlag] = useState(false);
  const [isSaveLoading, setIsSaveLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);

  useEffect(() => {
    if (activeTab === "products") {
      getInitialData();
    }
  }, [activeTab]);

  useEffect(() => {
    if (reportSuccess === true) {
      getInitialData();
    }
  }, [reportSuccess]);

  const getInitialData = async () => {
    setIsLoading(true);
    setPageNumber(1);
    await Promise.all([getProductData(1, "firstTimeApiCall"), getSiteFollowingProducts()]);
    setIsLoading(false);
  };

  const getProductData = async (pageNumber, firstTimeApiCall) => {
    try {
      setAllDataLoaded(true);
      const obj = {
        userId: currentUserId,
        SiteId: siteId,
        PageSize: 20,
        PageNumber: pageNumber
      };
      const res = await Postrequestcall(FETCH_PROJECT_SITE_PRODUCTS, obj, loginData?.accessToken);
      setNoOfProject(res?.data?.nrOfRecords);
      if (res.status === 200) {
        let resData = res?.data?.data ?? [];
        setHasMore(resData.length >= 20);
        const groupedData = resData.reduce((acc, item) => {
          const key =
            item?.manufacturerId === 0 || item?.manufacturerName?.trim() === ""
              ? "No Role"
              : item?.manufacturerName;

          if (!acc[key]) {
            acc[key] = {
              manufacturerId: item?.manufacturerId,
              manufacturerName:
                item?.manufacturerId === 0 || item?.manufacturerName?.trim() === ""
                  ? "No Manufacturer"
                  : item?.manufacturerName,
              items: []
            };
          }

          acc[key].items.push(item);
          return acc;
        }, {});

        let groupData = Object.values(groupedData);
        const noRoleData = groupData.find((group) => group?.manufacturerName === "No Role");
        if (noRoleData) {
          groupData = groupData.filter((group) => group?.manufacturerName !== "No Role");
          groupData.push(noRoleData);
        }

        if (pageNumber > 1) {
          setTimeout(() => {
            setProductData((prevProducts) => [...prevProducts, ...groupData]);
          }, 500);
        } else {
          setProductData(() => groupData);
          if (firstTimeApiCall) {
            setHasData(groupData?.length > 0);
          }
        }
        const allFollowingRecords = resData.every((record) => record?.isFollowing === true);
        setAllFollowing(allFollowingRecords);
      }
    } catch (error) {
      console.log("getProductData-> Error While Fetching Project Site Product: ", error);
    } finally {
      setShowSearchLaoder(false);
      setAllDataLoaded(false);
    }
  };

  const getSiteFollowingProducts = async () => {
    try {
      let getResponse = await Getrequestcall(
        `${GET_SITE_FOLLOWING_PRODUCTS}/${currentUserId}/${siteId}`,
        loginData?.accessToken
      );
      if (getResponse.status === 200) {
        let followRes = getResponse?.data?.data?.[0];
        setAllFollowing(followRes?.isFollowing);
      }
    } catch (error) {
      console.log(
        "getSiteFollowingProducts-> Error While Getting Site Following Products: ",
        error
      );
    }
  };

  const handleOpenReportModal = () => {
    setMoreMenuAnchorEl(null);
    let reportObj = {
      showReport: true,
      recordId: product.productId ?? 0,
      name: Pages?.companiesProducts?.name,
      AppScreenId: Pages?.companiesProducts?.id
    };
    console.log("report", reportObj);
    console.log("product", product);
    //return;
    dispatch(setShowReport(reportObj));
  };

  const onAddProductClick = () => {
    setShowAddProductModal(true);
  };

  const onItemClick = (item) => {
    navigate(`/product/${item?.productId}`);
    let mapModal = {
      open: false,
      from: "",
      select: ""
    };
    dispatch(setSelectedsite(null));
    dispatch(setShowmapmodal(mapModal));
    dispatch(setSelectedSiteId(0));
    dispatch(setSelectedProjectdata(null));
  };

  const onProductClick = (currentTarget, product) => {
    setProduct(product);
    setMoreMenuAnchorEl(currentTarget);
  };

  const increaseOffset = (callback) => {
    setPageNumber((prevPageNr) => prevPageNr + 1);
    callback(pageNumber + 1);
  };

  const saveProduct = async (productId) => {
    try {
      setIsLoading(true);
      const obj = {
        UserId: Number(currentUserId),
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: 0,
            SiteId: siteId,
            ProductId: productId,
            ModifiedBy: Number(currentUserId),
            RecordStatusId: 1
          }
        ]
      };
      await Postrequestcall(SAVE_SITE_PRODUCTS, obj, loginData?.accessToken);
      await getInitialData();
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log("saveProduct-> Error While Saving Site Product: ", error);
    }
  };

  const handleFollowPressed = () => {
    setRemoveProductAlert(true);
    setFollowFlag(true);
  };

  const handleFollowingPressed = () => {
    setRemoveProductAlert(true);
    setFollowFlag(false);
  };

  const handleSaveFollowClick = async (isFollow) => {
    try {
      setIsSaveLoading(true);
      const obj = {
        UserId: Number(currentUserId),
        SiteId: siteId,
        IsFollowing: isFollow
      };
      let getReponse = await Postrequestcall(SAVE_FOLLOWING_PRODUCTS, obj, loginData?.accessToken);
      if (getReponse.status === 201) {
        await getSiteFollowingProducts();
      }
      setIsSaveLoading(false);
    } catch (error) {
      console.log("handleSaveFollowClick-> Error While Following Products: ", error);
      setIsSaveLoading(false);
    }
  };

  const NoInformation = () => {
    return (
      <Stack  sx={{ gap: 1, height: "100%" }}>
        <Stack sx={{ display: "flex",  justifyContent: "flex-end", alignItems: "center" }}  direction={"row"}>
          {/* Count Removed */}
          <Button
            sx={{ textTransform: "none" }}
            variant="outlined"
            color="primary"
            onClick={onAddProductClick}>
            {TEXT_ADD_PRODUCT}
          </Button>
        </Stack>
        <Box className="empty-data-card">
          <Emptydata
            icon={<BuildIcon className="emptydata-icon" />}
            firstText={TEXT_NO_PRODUCTS_ADDED_YET}
          />
        </Box>
      </Stack>
    );
  };

  const renderListing = () => {
    return (
      <Box>
        <Stack sx={{ display: "flex",  justifyContent: "space-between", alignItems: "center" }}  direction={"row"}>
          <Stack direction={"row"} sx={{ alignItems: "center" }} spacing={1}>
            {/* Count Removed */}
            {productData?.length !== 0 && (
              <Stack direction={"row"} sx={{ alignItems: "center" }}>
                <Icon
                  fontSize="small"
                  color="primary"
                  sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                  <FiberManualRecordIcon fontSize="small" sx={{ fontSize: "10px" }} />
                </Icon>
                <Button
                  fullWidth
                  variant="text"
                  color="primary"
                  sx={{ textTransform: "none" }}
                  onClick={allFollowing ? handleFollowingPressed : handleFollowPressed}>
                  {allFollowing ? TEXT_FOLLOWING_ALL : TEXT_FOLLOW_ALL}
                </Button>
              </Stack>
            )}
          </Stack>
          <Button
            sx={{ textTransform: "none" }}
            variant="outlined"
            color="primary"
            onClick={onAddProductClick}>
            {TEXT_ADD_PRODUCT}
          </Button>
        </Stack>
        <Stack spacing={1}>
          {showSearchLoader ? (
            <Stack style={{ padding: "30px" }}>
              <Loader />
            </Stack>
          ) : productData?.length > 0 ? (
            <>
              <InfiniteScroll
                dataLength={productData?.length}
                next={async () => {
                  increaseOffset((pageNumber) => {
                    getProductData(pageNumber);
                  });
                }}
                hasMore={hasMore}
                loader={
                  !allDataLoaded ? null : (
                    <h4 style={{ display: "flex", justifyContent: "center" }}>
                      <Loader />
                    </h4>
                  )
                }
                scrollableTarget={scrollId}>
                <List disablePadding>
                  {productData.map((item) => (
                    <Box key={item?.manufacturerId ?? item?.id}>
                      <ListSubheader
                        key={`subheader-${item?.manufacturerId}`}
                        sx={{ pl: 0.5, cursor: "pointer" }}
                        onClick={() => {
                          item?.manufacturerId && navigate(`/manufacture/${item?.manufacturerId}`);
                        }}>
                        {item?.manufacturerName === "No Role"
                          ? TEXT_NO_ROLE
                          : item?.manufacturerName}
                      </ListSubheader>
                      <Stack spacing={1}>
                        {item?.items?.map((product, index) => (
                          <Card
                            key={index ?? product?.id ?? `${product?.productName}-${Math.random()}`}
                            className="pagelist-content">
                            <ListItem
                              style={{ padding: "0px" }}
                              secondaryAction={
                                <IconButton
                                  onClick={(event) => onProductClick(event.currentTarget, product)}>
                                  <MoreIcon />
                                </IconButton>
                              }>
                              <ListItemButton
                                onClick={() => {
                                  onItemClick(product);
                                }}>
                                <ListItemText
                                  primary={<Stack sx={{ pb: 0.5 }}>{product?.productName}</Stack>}
                                  secondary={
                                    product?.productType && (
                                      <span
                                        style={{
                                          backgroundColor: "lightgray",
                                          padding: "3px 5px",
                                          borderRadius: "4px"
                                        }}>
                                        {product?.productType}
                                      </span>
                                    )
                                  }
                                />
                              </ListItemButton>
                            </ListItem>
                          </Card>
                        ))}
                      </Stack>
                    </Box>
                  ))}
                </List>
                <Menu
                  anchorEl={moreMenuAnchorEl}
                  open={Boolean(moreMenuAnchorEl)}
                  onClose={() => setMoreMenuAnchorEl(null)}
                  anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                  transformOrigin={{ horizontal: "right", vertical: "top" }}>
                  <MenuItem onClick={() => handleOpenReportModal()} style={{ color: BIRed }} dense>
                    {TEXT_REPORT}
                  </MenuItem>
                </Menu>
              </InfiniteScroll>
            </>
          ) : (
            <Stack sx={{ justifyContent: "center", alignItems: "center" }} direction={"row"} style={{ color: BIGrey, padding: "30px" }}>
              {TEXT_NO_RESULTS_FOUND}
            </Stack>
          )}
        </Stack>
      </Box>
    );
  };

  return (
    <Box>
      {isLoading ? <CompanyListSkeleton /> : hasData ? renderListing() : <NoInformation />}
      {showAddProductModal && (
        <AddProductModal
          open={showAddProductModal}
          onClose={() => {
            setShowAddProductModal(false);
          }}
          from={"SiteCard"}
          mainId={siteId}
          saveProduct={saveProduct}
          title={TEXT_ADD_PRODUCT}
        />
      )}

      <PromptModal
        isOpen={removeProductAlert}
        onClose={() => {
          setRemoveProductAlert(false);
        }}
        title={followFlag ? TEXT_FOLLOW_ALERT : TEXT_UNFOLLOW_ALERT}
        redButtonText={TEXT_YES}
        onRedButtonClick={() => {
          handleSaveFollowClick(followFlag ? true : false);
        }}
        isLoading={isSaveLoading}
      />
    </Box>
  );
};

export default SitesProductSection;
